import React, { useState, useRef } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, Select } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { generate_uuid } from "lib/helpers";

import Modal from "components/Modal";

export default function AddItem(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{ uuid: generate_uuid(), config: [] }}
          onSubmit={async (values, { setSubmitting }) => {
            await props.addToList(values);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="عنوان منو"
                    label="عنوان منو :"
                    name="title"
                    component={TextField}
                  />

                  <Field
                    placeholder="عنوان انگلیسی منو"
                    label="عنوان انگلیسی منو :"
                    name="_en*title*text"
                    component={TextField}
                  />
                  <div>
                    <Field
                      placeholder="نوع لینک"
                      label="نوع لینک :"
                      name="type"
                      component={Select}
                      options={[
                        { label: "داخلی", value: "internal" },
                        { label: "خارجی", value: "external" },
                      ]}
                    />
                  </div>
                  <div>
                    <Field
                      label="والد :"
                      name="parent_id"
                      valueOnly
                      component={Select}
                      options={props.parents || []}
                    />
                  </div>
                  <Field
                    placeholder="ترتیب"
                    label="ترتیب :"
                    name="order"
                    component={TextField}
                  />

                  <Field
                    placeholder="لینک"
                    label="لینک :"
                    name="link"
                    component={TextField}
                  />
                  <Field
                    placeholder=" لینک انگلیسی"
                    label="لینک  انگلیسی:"
                    name="_en*link*text"
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
